import moment from 'moment';

import { setSessionExpiry } from '../../../store/authentication/actions';
import store from '../../../store/configureStore';

const extendSession = () => {
  /* Update the store with the new expiry time of the session, this will trigger a reset of the timeouts when it is
     recieved as a prop again. */

  return store.dispatch(
    setSessionExpiry(
      moment()
        .add(store.getState().authentication.sessionTotalLength, 'ms')
        .format(),
    ),
  );
};

export default extendSession;
export { extendSession };
